import React, { lazy } from "react";

const UploadAdditionalVideosPageLazy = lazy(() =>
  import("./index").then((module) => ({
    default: module.default,
  }))
);

export const UploadAdditionalVideosPage = (props) => (
  <UploadAdditionalVideosPageLazy {...props} />
);
